import React, { useState } from "react";
import { Button, FloatingLabel, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { useNavigate } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import { TypeAnimation } from "react-type-animation";
import addServiceImg from "../../assets/images/add-service/add-service.jpg";
import "./AddService.css";

const AddService = () => {
   const {
      register,
      handleSubmit,
      formState: { errors },
   } = useForm();

   const imageHostKey = process.env.REACT_APP_imgbb_key;
   const navigate = useNavigate();

   const [loading, setLoading] = useState(false);

   const handleAddService = (data) => {
      const image = data.image[0];
      const formData = new FormData();
      formData.append("image", image);

      setLoading(true);
      const url = `https://api.imgbb.com/1/upload?key=${imageHostKey}`;
      fetch(url, {
         method: "POST",
         body: formData,
      })
         .then((res) => res.json())
         .then((imgData) => {
            if (imgData.success) {
               console.log(imgData.data.url);
            }
            const service = {
               title: data.title,
               img: imgData.data.url,
               price: data.price,
               description: data.description,
            };
            console.log("service:", service);

            fetch("https://food-for-you-server.vercel.app/allservices", {
               method: "POST",
               headers: {
                  "content-type": "application/json",
               },
               body: JSON.stringify(service),
            })
               .then((res) => res.json())
               .then((result) => {
                  console.log(result);
                  toast.success(`${data.title} is added successfully`);
                  navigate("/services");
                  setLoading(false);
               })
               .catch((err) => toast.error(err.message));
         });
   };

   return (
      <div className="d-flex flex-column flex-md-row-reverse justify-content-between align-items-center add-container mt-2">
         <div
            className="d-flex justify-content-center add-image-container align-items-center"
         // data-aos="fade-down-left"
         // data-aos-duration="2500"
         >
            <PhotoProvider
               speed={() => 800}
               easing={(type) =>
                  type === 2
                     ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
                     : "cubic-bezier(0.34, 1.56, 0.64, 1)"
               }
            >
               <PhotoView src={addServiceImg}>
                  <LazyLoadImage
                     src={addServiceImg}
                     alt={addServiceImg}
                     className="rounded-3 add-img-width shado car"
                     placeholderSrc={addServiceImg}
                     effect="blur"
                     title={addServiceImg}
                     style={{ objectFit: "cover", cursor: "pointer" }}
                  />
               </PhotoView>
            </PhotoProvider>
         </div>

         <div
            className="add-service-form"
         // data-aos="fade-down-right"
         // data-aos-duration="2500"
         >
            <div className="mx-auto shadow p-4 rounded-3 card-log border-top">
               <h4 className="mb-4 text-primar text-center fw-bold form-header">
                  <TypeAnimation
                     sequence={["Add A Service", 3000]}
                     speed={0}
                     cursor={true}
                     repeat={Infinity}
                  />
               </h4>

               <Form onSubmit={handleSubmit(handleAddService)}>
                  <Form.Group className="mb-3 fw-semibold" controlId="formBasicName">
                     <Form.Label>Service Title</Form.Label>
                     <Form.Control
                        className="border border-1"
                        type="text"
                        placeholder="Enter Service Title"
                        {...register("title", {
                           required: "Service Title is required",
                        })}
                     />
                     {errors.title && (
                        <p className="text-danger fw-semibold text-start mt-2">
                           {errors.title?.message}
                        </p>
                     )}
                  </Form.Group>

                  <Form.Group className="mb-3 fw-semibold" controlId="formBasicName">
                     <Form.Label>Image</Form.Label>
                     <Form.Control
                        className="border border-1"
                        placeholder="Add Service Image"
                        type="file"
                        {...register("image", {
                           required: "Image is required",
                        })}
                     />
                     {errors.image && (
                        <p className="text-danger fw-semibold text-start mt-2">
                           {errors.image?.message}
                        </p>
                     )}
                  </Form.Group>

                  <Form.Group className="mb-3 fw-semibold" controlId="formBasicName">
                     <Form.Label>Price</Form.Label>
                     <Form.Control
                        className="border border-1"
                        type="text"
                        placeholder="Enter Price ($)"
                        {...register("price", { required: "Price is required" })}
                     />
                     {errors.price && (
                        <p className="text-danger fw-semibold text-start mt-2">
                           {errors.price?.message}
                        </p>
                     )}
                  </Form.Group>

                  <Form.Group>
                     <Form.Label className="fw-semibold">Description</Form.Label>
                     <FloatingLabel
                        controlId="floatingTextarea"
                        label="Enter Description"
                        className="mb-4 text-secondary"
                     >
                        <Form.Control
                           as="textarea"
                           placeholder="Enter Description"
                           style={{ height: "100px" }}
                           {...register("description", {
                              required: "Description is required",
                           })}
                        />
                        {errors.description && (
                           <p className="text-danger fw-semibold text-start mt-2">
                              {errors.description?.message}
                           </p>
                        )}
                     </FloatingLabel>
                  </Form.Group>

                  <div className="m-btn-add">
                     <Button variant="primary" type="submit" className="reg-btn w-100">
                        {loading ? (
                           <div className="d-flex justify-content-center align-items-center py-1">
                              <ScaleLoader
                                 color="#fff"
                                 height="13"
                                 speedMultiplier=".6"
                              />
                           </div>
                        ) : (
                           "Add Service"
                        )}
                     </Button>
                  </div>
               </Form>
            </div>
         </div>
      </div>
   );
};

export default AddService;
